import { useTranslation } from 'react-i18next';
import { WalletActionType } from '../types/walletActionType';
import ActionButton from 'components/ActionButton.tsx/ActionButton';
import { useConfigurationContext } from 'store/configurationContext';

type WalletActionsProps = {
	className?: string;
	walletActionType: string;
	disabledDeposit: boolean;
	onAction: (action: WalletActionType) => void;
};

export const WalletActions = (props: WalletActionsProps) => {
	const { t } = useTranslation();
	const { configurationState } = useConfigurationContext();

	const themeColor = configurationState.find((item) => item.configKey === 'theme_color')?.value || '';
	const secondary_color = configurationState.find((item) => item.configKey === 'secondary_color')?.value || '';
	return (
		<article className={`flex gap-2 ${props.className} `}>
			<ActionButton
				htmlType='button'
				type='default'
				shape='round'
				className='xss:text-[11px] sm:text-sm xss:!ps-2 xss:!pe-2 md:!ps-4 md:!pe-4 h-9'
				style={
					props.walletActionType === WalletActionType.WITHDRAW
						? { backgroundColor: themeColor, border: 'none', color: secondary_color }
						: { backgroundColor: 'transparent' }
				}
				onClick={() => props.onAction(WalletActionType.WITHDRAW)}
			>
				{t('WITHDRAW_FROM_MT5')}
			</ActionButton>
			<ActionButton
				htmlType='button'
				type='default'
				shape='round'
				disabled={props.disabledDeposit}
				tooltip={props.disabledDeposit ? t<string>('youAreNottAllowed') : ''}
				className='xss:text-[11px] sm:text-sm xss:!ps-2 xss:!pe-2 md:!ps-4 md:!pe-4 h-9'
				style={
					props.walletActionType === WalletActionType.DEPOSIT
						? { backgroundColor: themeColor, border: 'none', color: secondary_color }
						: { backgroundColor: 'transparent' }
				}
				onClick={() => props.onAction(WalletActionType.DEPOSIT)}
			>
				{t('DEPOSIT_TO_MT5')}
			</ActionButton>
		</article>
	);
};
